'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input$1 = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
var boxShadow = require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
var borders = require('../../../../themes/borders.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
var input = require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var baseDatePicker = require('../base-date-picker/base-date-picker.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledStandardDatePicker = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    return /*#__PURE__*/ React__default.default.createElement(baseDatePicker.BaseDatePicker, _extends({}, props, {
        className: classnames__default.default({
            'bf-date-picker__standard': true,
            [`${props?.className}`]: !!props?.className
        }),
        ref: ref
    }));
});
const StyledStandardDatePicker = styled__default.default(UnstyledStandardDatePicker)`
  .bf-date-picker__input-wrapper {
    position: relative;
  }

  .bf-date-picker__textfield {
    ${input.baseInputStyle}
    ${()=>input.getInputPadding({})}
    ${()=>input.getInputBorderRadius({})}
    ${({ error , look  })=>input.getInputTheme({
        error,
        look
    })}

    .bf-textfield__textfield {
      padding-right: 40px;
    }
  }

  /* internal error */
  &.bf-date-picker--error {
    .bf-date-picker__textfield {
      ${({ look  })=>input.getInputTheme({
        error: 'internal',
        look
    })}
    }
  }

  .bf-date-picker__calendar-icon-button {
    bottom: 9px;
    min-height: 0;
    padding: 8px;
    position: absolute;
    right: 9px;
  }

  .bf-date-picker__dialog {
    background-color: ${colors.BrandfolderHexColors.White};
    ${boxShadow.boxShadowDialogs}
    border-radius: ${borders.borderRadiusMedium}px;
    padding: 16px;
    width: 256px;
    z-index: 1;
  }

  .bf-date-picker__header {
    align-items: center;
    display: flex;
    margin-bottom: 12px;
  }

  .bf-date-picker__header-button {
    height: 20px;
    min-height: 0;
    padding: 0;
    width: 20px;

    .bf-button__close-icon,
    .bf-button__font-icon {
      font-size: 11px;
    }
  }

  .bf-date-picker__previous-month-button {
    margin-left: auto;
  }

  .bf-date-picker__next-month-button {
    margin-left: 8px;

    .bf-button__font-icon {
      margin-left: 3px;
    }
  }

  .bf-date-picker__heading {
    color: ${colors.BrandfolderHexColors.Text};
    font-family: ${fonts.fontFamilyMedium};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  }

  .bf-date-picker__close-button {
    margin-left: 8px;

    &.bf-date-picker__close-button--hidden {
      ${screenReader.screenReaderOnly}
    }
  }

  .bf-date-picker__grid {
    border-collapse: collapse;
    width: 100%;
  }

  .bf-date-picker__columnheader,
  .bf-date-picker__grid-cell {
    text-align: center;
    width: 32px;
  }

  .bf-date-picker__columnheader {
    color: ${colors.BrandfolderHexColors.GrayDark};
    font-family: ${fonts.fontFamilyBook};
    font-size: 12px;
    font-weight: 400;
    height: 24px;
    line-height: 18px;
  }

  .bf-date-picker__today {
    background-color: ${colors.BrandfolderHexColors.PurplePopsicle};
    border-radius: 50%;
    bottom: 3px;
    height: 4px;
    left: calc(50% - 2px);
    position: absolute;
    width: 4px;

    [aria-selected='true']& {
      background-color: ${colors.BrandfolderHexColors.White};
    }
  }

  .bf-date-picker__grid-cell {
    background-color: ${colors.BrandfolderHexColors.White};
    border-radius: ${borders.borderRadiusMedium}px;
    color: ${colors.BrandfolderHexColors.Text};
    font-family: ${fonts.fontFamilyBook};
    font-size: 14px;
    font-weight: 400;
    height: 32px;
    line-height: 22px;
    outline: 0;
    position: relative;

    &:hover:not(:empty),
    &[tabindex='0'] {
      background-color: ${colors.BrandfolderHexColors.DirtyMarshmallow};
      cursor: pointer;
    }

    &[aria-disabled='true'],
    &[aria-disabled='true']:hover {
      background-color: ${colors.BrandfolderHexColors.White};
      color: ${colors.BrandfolderHexColors.GrayMediumDark};
      cursor: not-allowed;
    }

    &[aria-selected='true'],
    &[aria-selected='true']:hover {
      background-color: ${colors.BrandfolderHexColors.PurplePopsicle};
      color: ${colors.BrandfolderHexColors.White};
      cursor: default;
    }

    &[aria-selected='true'] {
      .bf-date-picker__today {
        background-color: ${colors.BrandfolderHexColors.White};
      }
    }
  }
`;
/**
 * A date picker component that allows a user to enter a date via a text field, or select a date from a calendar.
 *
 * Required props include `id`, `labels`, and `onSelection`.
 *
 * To disallow selecting dates in the past, pass `allowPastDates={false}` prop.
 * Note that `defaultSelectedDate` will be respected even when `allowPastDates` is `false` for things like due dates.
 *
 * Setting `disabled` to `true` will disable the input and the calendar button.
 * Setting `readOnly` to true will set the input to `readOnly` and disable the calendar button.
 *
 * `showCloseButton` and `showLabel` both default to `false`, but will still be accessible by screen readers.
 *
 * https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/examples/datepicker-dialog/
 *
 * @param props StandardDatePickerProps
 * @returns FunctionComponent<StandardDatePickerProps>
 */ const StandardDatePicker = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { labelPosition =input$1.InputLabelPositions.Top , look =input$1.InputLooks.Default , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledStandardDatePicker, _extends({}, otherProps, {
        labelPosition: labelPosition,
        look: look,
        ref: ref
    })));
});

exports.StandardDatePicker = StandardDatePicker;
exports.UnstyledStandardDatePicker = UnstyledStandardDatePicker;
//# sourceMappingURL=standard-date-picker.js.map
